import { observer } from 'mobx-react';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { itemsForDealModalStore } from '../../store';
import { localeStore } from 'src/mobx/localesStore';
import { IDealItem } from 'src/types/combo';
import { IProductV4 } from 'src/types/product';
import { getTranslate } from 'src/utils/helpers';
import { TOOLTIP_DURATION, TOOLTIP_POSITION } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import TooltipIcon from '~/view/components/TooltipIcon/TooltipIcon';
import './style.scss';

enum ITEM_STATE {
  AVAILABLE,
  DONATABLE,
  HAS_SIZE,
  HAS_MODIFIERS,
  HAS_EXCLUSIONS,
}

enum ITEM_AVAILABILITY {
  AVAILABLE,
  NOT_AVAILABLE,
  OUT_OF_STOCK,
}

interface IProps {
  item?: IProductV4 | IDealItem;
}

@observer
export default class ItemsForDealModalItem extends React.Component<IProps, {}> {
  clickItem = () => {
    if ((!this.isAvailability && !this.isActive) || !this.props.item) return;

    itemsForDealModalStore.selectItem(this.props.item);
  };

  get itemState(): ITEM_STATE {
    if (!this.props.item) return ITEM_STATE.AVAILABLE;

    if (this.props.item.is_required_modifiers) return ITEM_STATE.HAS_MODIFIERS;
    if (this.props.item.is_size) return ITEM_STATE.HAS_SIZE;
    if (this.props.item.is_exclusions) return ITEM_STATE.HAS_EXCLUSIONS;
    if (this.props.item.is_donation) return ITEM_STATE.DONATABLE;

    return ITEM_STATE.AVAILABLE;
  }

  get itemAvailability(): ITEM_AVAILABILITY {
    if (!this.props.item) return ITEM_AVAILABILITY.AVAILABLE;

    if (!this.props.item.status) return ITEM_AVAILABILITY.NOT_AVAILABLE;
    if (this.props.item.out_of_stock) return ITEM_AVAILABILITY.OUT_OF_STOCK;

    return ITEM_AVAILABILITY.AVAILABLE;
  }

  get stateMessage(): string {
    if (this.itemState === ITEM_STATE.HAS_MODIFIERS) return 'modifier_dc_conflict';
    if (this.itemState === ITEM_STATE.HAS_SIZE) return 'sizes_dc_conflict';
    if (this.itemState === ITEM_STATE.HAS_EXCLUSIONS) return 'exclusion_dc_conflict';
    if (this.itemState === ITEM_STATE.DONATABLE) return 'donatable_dc_conflict';
    return '';
  }

  get availabilityMessage(): string {
    if (this.itemAvailability === ITEM_AVAILABILITY.NOT_AVAILABLE) return 'not_available';
    if (this.itemAvailability === ITEM_AVAILABILITY.OUT_OF_STOCK) return 'out_of_stock';
    return '';
  }

  get isActive(): boolean {
    return itemsForDealModalStore.selectedItems.some((item) => item.id === this.props.item?.id);
  }

  get isAvailability(): boolean {
    return this.itemState === ITEM_STATE.AVAILABLE;
  }

  get className(): string {
    let className: string = 'custom-modal__item mb-2 mr-2';

    if (this.isActive && !this.isAvailability) {
      className += ' items-for-deal-modal-item_unavailable-active';
      return className;
    }
    if (this.isActive) className += ' custom-modal__item_active';
    if (!this.isAvailability) className += ' items-for-deal-modal-item_unavailable';

    return className;
  }

  render() {
    return (
      <>
        {this.props.item ? (
          <li className={this.className}>
            <div className="custom-modal__item__name-wrapper justify-content-between px-3" onClick={this.clickItem}>
              <p className="custom-modal__item__name">{getTranslate(this.props.item.name)}</p>
            </div>
            {this.itemAvailability === ITEM_AVAILABILITY.NOT_AVAILABLE || this.itemAvailability === ITEM_AVAILABILITY.OUT_OF_STOCK ? (
              <div className={`custom-modal__item__profile-name-wrapper ${this.isAvailability ? 'pr-3' : ''}`} onClick={this.clickItem}>
                <p className="custom-modal__item__profile-name letter-spacing-12 px-2 py-1">{localeStore.t(this.availabilityMessage)}</p>
              </div>
            ) : null}
            {!this.isAvailability ? (
              <TooltipIcon
                message={this.stateMessage}
                duration={TOOLTIP_DURATION.EXTRA_LARGE}
                position={TOOLTIP_POSITION.PORTAL}
                maxWidth={this.itemState === ITEM_STATE.DONATABLE || this.itemState === ITEM_STATE.HAS_SIZE ? 246 : 308}
                gapTop={-5}
                wrapperClassName="d-flex full-height align-items-center justify-content-center"
                iconClassName="m-3"
              />
            ) : null}
          </li>
        ) : (
          <div className="custom-modal__item custom-modal__item__skeleton mb-2 mr-2">
            <Skeleton width="100%" height="100%" />
          </div>
        )}
      </>
    );
  }
}
